import { render, staticRenderFns } from "./my-task.vue?vue&type=template&id=2bc4886f&scoped=true&"
import script from "./my-task.vue?vue&type=script&lang=js&"
export * from "./my-task.vue?vue&type=script&lang=js&"
import style0 from "./my-task.vue?vue&type=style&index=0&id=2bc4886f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4886f",
  null
  
)

export default component.exports